<template>
  <v-container class="pa-0" fluid style="background-color: transparent">
    <v-container style="background-color: transparent">
      <v-row dense style="background-color: transparent">
        <v-col cols="auto">
          <gradient-bar />
          <h6
            class="primary--text font-weight-bold mt-4"
            style="font-size: 19px"
          >
            Diferencial
          </h6>
        </v-col>
      </v-row>

      <v-row
        dense
        class="slide-left-to-right mt-6"
        style="background-color: transparent !important"
      >
        <v-col
          cols="12"
          md="6"
          class="pr-md-8"
          style="background-color: transparent !important"
        >
          <h3 class="clipedText primary mb-6">
            <strong
              >O professor certo, no horário certo, pelo preço certo.</strong
            >
          </h3>

          <div
            class="poppins body-text mb-4"
            style="background-color: transparent !important"
          >
            Na plataforma Pitch você pode encontrar o
            <strong>professor ideal</strong> para
            <strong>o seu objetivo</strong>, com
            <strong>disponibilidade</strong> que te atende e
            <strong>valores que cabem no seu bolso!</strong>
          </div>

          <div class="poppins body-text mb-8">
            E o preço das aulas? Você combina
            <strong
              >dias, horários e valores diretamente com o professor.</strong
            >
            Basta preencher o formulário com suas preferências e o sistema irá
            indicar o professor mais adequado para você. Depois, o professor
            apresenta as opções de disponibilidade e valores, e vocês ajustam
            tudo de forma <strong>transparente e personalizada!</strong> 😁
          </div>

          <v-btn
            rounded
            color="primary"
            class="font-weight-black text-none px-8"
            large
            @click="openLink()"
            style="
              width: fit-content;
              display: flex;
              font-size: clamp(0.7rem, 2.6vw, 0.875rem);
            "
          >
            Encontre o professor certo
          </v-btn>
        </v-col>

        <v-col cols="12" md="6" class="mt-10 mt-md-0">
          <v-card flat color="transparent">
            <v-row dense no-gutters>
              <v-col cols="9" class="pr-2">
                <v-img
                  src="@/assets/images/differential/teacher-min.png"
                  style="border-radius: 8px"
                  class="elevation-1"
                  :aspect-ratio="16 / 9"
                ></v-img>
              </v-col>

              <v-col cols="3">
                <v-row dense no-gutters>
                  <v-col cols="12" class="mb-2">
                    <v-img
                      src="@/assets/images/differential/teacher_mini_1-min.png"
                      style="border-radius: 5px"
                      :aspect-ratio="16 / 9"
                    ></v-img>
                  </v-col>
                  <v-col cols="12" class="mb-2">
                    <v-img
                      src="@/assets/images/differential/teacher_mini_2-min.png"
                      style="border-radius: 5px"
                      :aspect-ratio="16 / 9"
                    ></v-img>
                  </v-col>
                  <v-col cols="12">
                    <v-img
                      src="@/assets/images/differential/teacher_mini_3-min.png"
                      style="border-radius: 5px"
                      :aspect-ratio="16 / 9"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row dense class="mt-6" align="center" justify="center">
              <v-col
                v-for="img in ['TOEFL', 'cambridge', 'IELTS']"
                :key="img"
                cols="4"
                class="d-flex justify-center"
              >
                <v-img
                  :src="require(`@/assets/images/differential/${img}-min.png`)"
                  contain
                  max-height="45"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense class="mt-16 mb-6">
        <v-col cols="12" align="center" justify="center">
          <span
            class="primary--text font-weight-bold"
            style="font-size: 1.25rem"
          >
            Veja o que dizem os alunos que
            <strong>alcançaram seus sonhos e objetivos</strong> no inglês com a
            ajuda de nossos professores licenciados
          </span>
        </v-col>
      </v-row>

      <v-row dense style="background-color: transparent">
        <v-col cols="12">
          <v-carousel
            hide-delimiters
            height="auto"
            style="background-color: transparent"
            v-if="$vuetify.breakpoint.mdAndUp"
          >
            <v-carousel-item v-for="(pair, i) in evidences" :key="'d' + i">
              <v-row dense>
                <v-col
                  v-for="(item, idx) in pair"
                  :key="idx"
                  cols="12"
                  md="6"
                  class="pa-4"
                >
                  <v-card
                    flat
                    outlined
                    color="transparent"
                    class="pa-6 d-flex flex-column"
                    style="
                      min-height: 320px;
                      border-radius: 15px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                    "
                  >
                    <v-img
                      src="@/assets/icons/quotes.svg"
                      width="24"
                      height="24"
                      contain
                      class="mb-4"
                    ></v-img>
                    <div
                      class="poppins body-2 mb-auto grey--text text--darken-3"
                    >
                      {{ item.text }}
                    </div>
                    <div class="d-flex align-center justify-end mt-4">
                      <div class="text-right mr-3">
                        <h6 class="primary--text font-weight-bold mb-0">
                          {{ item.name }}
                        </h6>
                        <small class="grey--text">{{ item.address }}</small>
                      </div>
                      <v-avatar size="48">
                        <v-img :src="item.avatar"></v-img>
                      </v-avatar>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-carousel-item>
          </v-carousel>
          <v-carousel
            hide-delimiters
            height="auto"
            style="background-color: transparent"
            v-if="$vuetify.breakpoint.smAndDown"
          >
            <v-carousel-item
              v-for="(item, i) in evidencesMobile"
              :key="'m' + i"
            >
              <v-card
                flat
                outlined
                color="transparent"
                class="pa-6 mx-2"
                style="
                  min-height: 350px;
                  border-radius: 15px;
                  border: 1px solid rgba(0, 0, 0, 0.1);
                "
              >
                <v-img
                  src="@/assets/icons/quotes.svg"
                  width="20"
                  height="20"
                  contain
                  class="mb-4"
                ></v-img>
                <div class="poppins body-2 grey--text text--darken-3">
                  {{ item.text }}
                </div>
                <div class="d-flex align-center justify-end mt-6">
                  <div class="text-right mr-3">
                    <h6 class="primary--text font-weight-bold mb-0">
                      {{ item.name }}
                    </h6>
                    <small class="grey--text">{{ item.address }}</small>
                  </div>
                  <v-avatar size="40">
                    <v-img :src="item.avatar"></v-img>
                  </v-avatar>
                </div>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "DiferentialSection",
  components: {},
  mixins: [],
  props: {},
  computed: {
    screenSize() {
      const size = window.innerWidth;
      if (size >= 960) return "280px";
      else if (size >= 768 && size < 960) return "200px";
      else return "250px";
    },
    mini() {
      const size = window.innerWidth;

      if (size >= 960 && size <= 1280) return "35px";
      else if (size >= 768 && size < 959) return "30px";
      else return "25px";
    },
  },
  watch: {},
  mounted() {
    if (window.innerWidth < 960) this.isMobile = true;
  },
  methods: {
    selectButton(value) {
      this.selected = value;
    },
    openLink() {
      window.open(
        "https://forms.clickup.com/3118765/f/2z5nd-7833/PVZ6XREQVLDC4EXCP7",
        "_blank"
      );
    },
  },
  data() {
    return {
      selected: 1,
      isMobile: false,
      evidences: [
        [
          {
            name: "José Alício",
            address: "Cataguases/MG",
            avatar: require("@/assets/avatars/Alicio.svg"),
            text: "Sempre tive o inglês presente, mas faltava confiança para me destacar no mercado. A metodologia é direto ao ponto, focado na conversação e adaptado ao meu ritmo. Agora, a Pitch é meu passaporte para realizar o sonho de um intercâmbio. Estou confiante e preparado para conquistar novos horizontes!",
          },
          {
            name: "Paulo Ricardo",
            address: "Três Rios/RJ",
            avatar: require("@/assets/avatars/Ricardo.svg"),
            text: "Desistindo de cursos de inglês caros e monótonos, encontrei o Pitch English. Incrível metodologia, ótimos professores, ambiente descontraído e preço justo. Superei a vergonha de falar inglês e agora vejo portas se abrindo que nem imaginava.",
          },
        ],
        [
          {
            name: "Mayara Lima",
            address: "Juiz de Fora/MG",
            avatar: require("@/assets/avatars/Mayara.svg"),
            text: "Adoro estudar com minha irmã e meu namorado. Sempre que esqueço de fazer uma atividade ou perco a hora da aula, minha irmã está lá para me lembrar. É maravilhoso poder praticar inglês todos os dias com meu amor.",
          },
          {
            name: "Natália Brand",
            address: "Petrópolis/RJ",
            avatar: require("@/assets/avatars/Natalia.svg"),
            text: "Quando comecei o curso, admito que me senti insegura. A abordagem sobre gramática e exercícios parecia um pouco entediante. No entanto, desde então, tenho percebido uma grande evolução. As constantes novidades têm feito toda a diferença no aprendizado. Esta experiência tem sido a melhor que já tive com o inglês!",
          },
        ],
        [
          {
            name: "Beatriz Machado",
            address: "Juiz de Fora/MG",
            avatar: require("@/assets/avatars/Beatriz.svg"),
            text: "Estou no curso de inglês há um ano e meio. Em 2020, conheci a Pitch por várias recomendações positivas e agora sei que elas estavam certas! O Pitch é incrível e tem me ajudado a me apaixonar pelo inglês aos poucos, com ótimos professores e uma metodologia que faz a diferença.",
          },
          {
            name: "Matheus Barbosa",
            address: "Juiz de Fora/MG",
            avatar: require("@/assets/avatars/default.svg"),
            text: `As aulas são incrivelmente divertidas; estou simplesmente adorando! Com essa abordagem descontraída de bate-papo, o tempo passa voando e, quando percebemos, ficamos surpresos, pensando: "Já acabou?"`,
          },
        ],
      ],
      evidencesMobile: [
        {
          name: "José Alício",
          address: "Cataguases/MG",
          avatar: require("@/assets/avatars/Alicio.svg"),
          text: "Sempre tive o inglês presente, mas faltava confiança para me destacar no mercado. O curso é direto ao ponto, focado na conversação e adaptado ao meu ritmo. Agora, a Pitch é meu passaporte para realizar o sonho de um intercâmbio. Estou confiante e preparado para conquistar novos horizontes!",
        },
        {
          name: "Paulo Ricardo",
          address: "Três Rios/RJ",
          avatar: require("@/assets/avatars/Ricardo.svg"),
          text: "Desistindo de cursos de inglês caros e monótonos, encontrei a Pitch English. Incrível metodologia, ótimos professores, ambiente descontraído e preço justo. Superei a vergonha de falar inglês e agora vejo portas se abrindo que nem imaginava.",
        },

        {
          name: "Mayara Lima",
          address: "Juiz de Fora/MG",
          avatar: require("@/assets/avatars/Mayara.svg"),
          text: "Adoro estudar com minha irmã e meu namorado. Sempre que esqueço de fazer uma atividade ou perco a hora da aula, minha irmã está lá para me lembrar. É maravilhoso poder praticar inglês todos os dias com meu amor.",
        },
        {
          name: "Natália Brand",
          address: "Petrópolis/RJ",
          avatar: require("@/assets/avatars/Natalia.svg"),
          text: "Quando comecei o curso, admito que me senti insegura. A abordagem sobre gramática e exercícios parecia um pouco entediante. No entanto, desde então, tenho percebido uma grande evolução. As constantes novidades têm feito toda a diferença no aprendizado. Esta experiência tem sido a melhor que já tive com o inglês!",
        },

        {
          name: "Beatriz Machado",
          address: "Juiz de Fora/MG",
          avatar: require("@/assets/avatars/Beatriz.svg"),
          text: "Estou no curso de inglês há um ano e meio. Em 2020, conheci o Pitch por várias recomendações positivas e agora sei que elas estavam certas! A Pitch é incrível e tem me ajudado a me apaixonar pelo inglês aos poucos, com ótimos professores e uma metodologia que faz a diferença.",
        },
        {
          name: "Matheus Barbosa",
          address: "Juiz de Fora/MG",
          avatar: require("@/assets/avatars/default.svg"),
          text: `As aulas são incrivelmente divertidas; estou simplesmente adorando! Com essa abordagem descontraída de bate-papo, o tempo passa voando e, quando percebemos, ficamos surpresos, pensando: "Já acabou?"`,
        },
      ],
    };
  },
};
</script>

<style scoped>
.clipedText {
  background: linear-gradient(90deg, #9923cd, #e8276f);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.poppins {
  font-family: "Poppins", sans-serif !important;
  line-height: 1.6;
}

.body-text {
  color: #5f5f61;
  font-size: 1.1rem;
}

/* Garante transparência em componentes internos do Vuetify */
.v-card,
.v-sheet,
.v-carousel {
  background-color: transparent !important;
}

/* Fix para o zoom: impede que os textos fiquem colados */
.v-application .pa-4 {
  padding: 16px !important;
}
</style>
